import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container } from 'reactstrap'
import DatePickerModal from 'components/Modals/DatePicker'
import { useLocation } from 'react-router-dom'
import moment from 'moment'

const headerStyle = { display: 'flex', alignItems: 'center', backgroundColor: '#EFEFEF', padding: '0.4rem 0rem', margin: '30px', marginBottom: 0, paddingLeft: '15px', color: '#053f7f', fontSize: 'larger' }

export default function Archive({ user, jwtToken, role = 'patient', dates }) {
    const location = useLocation()
    const [togglePicker, setTogglePicker] = useState(false)
    const [eventReports, setEventReports] = useState({ links: [], length: 0, dates: dates || location?.state?.dates, currentPage: 0 })
    const [annotaionReports, setAnnotaionReports] = useState({ links: [], length: 0, dates: [], currentPage: 0 })
    const [monthlyReports, setMonthlyReports] = useState({ links: [], length: 0, dates: dates || location?.state?.dates, currentPage: 0 })
    const [realtimeReports, setRealtimeReports] = useState({ links: [], length: 0, dates: dates || location?.state?.dates, currentPage: 0 })
    const [arrythmiaReports, setArrythmiaReports] = useState({ links: [], length: 0, dates: dates || location?.state?.dates, currentPage: 0 })

    const filterDates = (timestamp, dates) => {
        if (!dates.length) {
            return true
        }
        return new Date(timestamp) >= new Date(dates[0]) && new Date(timestamp) <= new Date(dates[1])
    }

    const Header = ({ reports, setReports, title }) => {
        const linksFilterd = reports.links?.filter((link) => filterDates(fixTimestamp(link.timestamp), reports.dates))

        const onClear = () => {
            setReports((prev) => ({ ...prev, currentPage: 0, dates: [] }))
        }

        const PagingNav = () => {
            const lastIndex = reports.currentPage + 5 > linksFilterd?.length ? linksFilterd.length : reports.currentPage + 5
            const leftDisable = reports.currentPage < 1
            const rightDisable = reports.currentPage + 5 >= linksFilterd?.length

            return (
                <div style={{ minWidth: '130px', display: 'flex' }} >
                    <div style={{ marginLeft: 'auto' }} >
                        <i className="fas fa-arrow-left"
                            style={{ opacity: leftDisable ? '.3' : '1', cursor: leftDisable ? 'default' : 'pointer' }}
                            onClick={() => previousPage(reports, setReports)} />

                        <div style={{ padding: '0px  10px', display: 'inline' }}>
                            {linksFilterd?.length > 0 ? reports?.currentPage + 1 : 0}{lastIndex > 1 ? `-${lastIndex}` : ''} of {linksFilterd?.length}
                        </div>
                        <i className="fas fa-arrow-right"
                            style={{ opacity: rightDisable ? '.3' : '1', cursor: rightDisable ? 'default' : 'pointer' }}
                            onClick={() => rightDisable ? null : nextPage(reports, setReports)} />
                    </div>
                </div>
            )
        }

        return (
            <div style={headerStyle} >
                {title} reports
                <div style={{ marginLeft: 'auto', paddingRight: '10px', display: 'flex', alignItems: 'center' }}>
                    {reports.dates.length ?
                        <>
                            <i className="fas fa-times-circle"
                                style={{ fontSize: 'smaller', opacity: 0.7, padding: '0px 5px', cursor: 'pointer' }}
                                onClick={onClear} />
                            <div style={{ fontSize: 'smaller', opacity: 0.7 }}>
                                {new Date(reports.dates[0]).toLocaleDateString('en-GB')} - {new Date(reports.dates[1]).toLocaleDateString('en-GB')}
                            </div>
                        </>
                        : ''}
                    <img alt='date'
                        src={require(`../../assets/img/icons/timefilter.svg`).default}
                        style={{ margin: '0px 15px', height: '2rem', cursor: 'pointer' }}
                        onClick={() => setTogglePicker(title)} />
                    <PagingNav />

                </div>
            </div>
        )
    }

    useEffect(() => {
        axios.post(
            `${process.env.REACT_APP_API_URL}/app/${role}/get-patinet-report-links`,
            { patientName: `${user.firstName}-${user.lastName}`, patientId: user.id },
            { headers: { 'Authorization': `Bearer ${jwtToken}` } }
        )
            .then(({ data }) => {
                const { eventsLinks, monthlyLinks, annotationLinks, realtimeLinks, arrythmiaLinks } = data
                setEventReports({ ...eventReports, links: eventsLinks, length: eventsLinks.length })
                setAnnotaionReports({ ...annotaionReports, links: annotationLinks, length: annotationLinks.length })
                setMonthlyReports({ ...monthlyReports, links: monthlyLinks, length: monthlyLinks.length })
                setRealtimeReports({ ...realtimeReports, links: realtimeLinks, length: realtimeLinks?.length })
                setArrythmiaReports({ ...arrythmiaReports, links: arrythmiaLinks, length: arrythmiaLinks?.length })
            })

    }, [])

    const previousPage = (reports, setReports) => {
        if (reports.currentPage < 5) {
            return
        }
        else {
            setReports({ ...reports, currentPage: reports.currentPage - 5 })
        }
    }
    const nextPage = (reports, setReports) => {
        if (reports.currentPage + 5 >= reports.length) {
            return
        }
        else {
            setReports({ ...reports, currentPage: reports.currentPage + 5 })
        }
    }

    const ReportLink = ({ name, href }) =>
        <div className='report-link'>
            <img alt="icon" src={require(`../../assets/img/icons/PDF.svg`).default} style={{ margin: '0px 15px', height: '1.5rem' }} />
            <a target="_blank" rel="noreferrer" href={href}> {name} </a>
        </div>

    const RealtimeReportLink = ({ name, data }) =>
        <div className='realtime-report-link' style={{ cursor: 'pointer' }} onClick={() => {
            localStorage.setItem('realtimeData', JSON.stringify(data.jsonObject))
            return window.open("/static/reports/realtime/", "_blank")
        }}>
            <img alt="icon" src={require(`../../assets/img/icons/PDF.svg`).default} style={{ margin: '0px 15px', height: '1.5rem' }} />
            <div> {name} </div>
        </div>

    const onConfirm = (year, startDate, endDate) => {
        const setReports = togglePicker === 'Monthly' ? setMonthlyReports : togglePicker === 'Event' ? setEventReports : togglePicker === 'Realtime' ? setRealtimeReports : togglePicker === 'Detailed measurement' ? setArrythmiaReports : setAnnotaionReports
        setReports((prev) => ({ ...prev, currentPage: 0, dates: [startDate || `01/01/${year}`, endDate || `12/31/${year}`] }))
    }

    const fixTimestamp = (timestamp, toUtc) => {
        const str = timestamp?.toString().padEnd(13, 0)
        if(toUtc) return moment(Number(str)).utc().format('DD MMM YYYY HH:mm')
        return moment(Number(str)).format('DD MMM YYYY HH:mm')
    }

    return (
        <Container fluid>
            <DatePickerModal
                isOpen={togglePicker !== false}
                toggle={setTogglePicker}
                onConfirm={onConfirm}
                chooseRange={true}
            />
            <div className="profile-content-container">
                <div style={{}}>
                    <Header setReports={setEventReports} reports={eventReports} title={'Measurements'} />
                    {eventReports.links?.filter((link) => filterDates(link.timestamp, eventReports.dates)).slice(eventReports.currentPage, eventReports.currentPage + 5).map((data, i) =>
                        <ReportLink
                            key={i}
                            name={fixTimestamp(data.timestamp)}
                            href={data.link} />
                    )}
                    {role !== 'patient' &&
                        <div>
                            <Header setReports={setRealtimeReports} reports={realtimeReports} title={'Realtime'} />
                            {realtimeReports.links?.filter((link) => filterDates(link.timestamp, realtimeReports.dates)).slice(realtimeReports.currentPage, realtimeReports.currentPage + 5).map((data, i) =>
                                <RealtimeReportLink
                                    key={i}
                                    name={fixTimestamp(data.timestamp)}
                                    data={data} />
                            )}
                        </div>
                    }
                    <Header setReports={setMonthlyReports} reports={monthlyReports} title={'Monthly'} />
                    {monthlyReports.links?.filter((link) => filterDates(link.timestamp, monthlyReports.dates)).slice(monthlyReports.currentPage, monthlyReports.currentPage + 5).map((data, i) =>
                        <ReportLink
                            key={i}
                            name={fixTimestamp(data.timestamp)}
                            href={data.link} />
                    )}
                    <Header setReports={setArrythmiaReports} reports={arrythmiaReports} title={'Detailed measurement'} />
                    {arrythmiaReports.links?.filter((link) => filterDates(fixTimestamp(link.timestamp, true), arrythmiaReports.dates)).slice(arrythmiaReports.currentPage, arrythmiaReports.currentPage + 5).map((data, i) =>
                        <ReportLink
                            key={i}
                            name={fixTimestamp(data.timestamp, true)}
                            href={data.link} />
                    )}
                    <br />
                </div>
            </div>
        </Container>
    )
}
